import DownTriangle from "../images/downtriangle.png"
import {useState,useEffect, useRef} from "react"
export default function HomePage(){

    const [x,setX] = useState(300);
    let y=0;
    
    
    useEffect(()=>{
        var xr = setInterval(()=>{
            setX(Math.floor(Math.random() * 1000))
            if (y>34){
                clearInterval(xr)
                setX("a lot of")
            }
            y++
        },100)
    },[])

    return (
        <div class="cc bg-[#282828] text-white">
            <div class="h-8"></div>
            <div class="flex flex-row">
                <div class="flex font-bold w-full sm:w-2/6 text-3xl sm:text-6xl">
                    <div class="m-auto">CXEEN</div>
                </div>
                <div class="hidden sm:flex w-6/12 text-2xl font-bold mt-10 gap-12 flex-row">
                    <div class="underline flex gap-3 mt-1 " >use for<span class="mt-3"><img src={DownTriangle} class="w-3" alt="Down"/></span></div>
                    <div class="mt-1">why us</div> 
                    <div class="mt-1">share something deep</div>
                </div>
                <div class="hidden sm:block w-3/12 flex mt-6  flex-col">
                    <div class=" w-60 mb-3 m-auto text-3xl pt-1 pb-2 px-4 bg-[#734809] ">Sign Up</div>
                    <div class=" text-xs m-auto">**currently waiting list</div>
                </div>
            </div>
            <div class="h-16"></div>
            <div>
                <div class="px-6 text-xl sm:text-5xl mt-4">
                    Untangle the deeper curiosities
                </div>
                <div class="px-6 tracking-widest font-bold text-[#A62003] text-3xl sm:text-5xl mt-4">
                    MAKE AI ARRANGE YOUR BOOKMARKS
                </div>
            </div>
            <div class="h-4 sm:h-16"></div>
            <div class="flex flex-row justify-center">
                <div class="sm:text-4xl mt-3 sm:mt-6">You have </div>
                <div class="w-16 sm:w-40 relative">
                    <div class={` ${x=="a lot of"?"sm:mt-6 mt-3 text-normal sm:text-4xl":"sm:mt-2 text-3xl sm:text-6xl"}`}>{x=="a lot of"?"a lot of":x}</div>
                    <div class="flex flex-col -left-20 sm:-left-16 top-12 sm:top-24 absolute overflow-x-visible w-60 sm:w-80">
                        <div class="m-auto p-2 px-4 text-normal w-40 sm:w-60 sm:text-2xl mb-3 bg-[#734809]">give access</div>
                        <div class="m-auto text-xs">*No modification to browser bookmarks</div>
                        <div class="m-auto text-xs">**currently waiting list</div>
                    </div>
                </div>
                <div class="sm:text-4xl mt-3 sm:mt-6"> bookmarks unarranged</div>
            </div>
            <div class="h-40 sm:h-60"></div>
            <div class="relative mx-4 sm:text-3xl flex gap-4 flex-col">
                <div class="sm:ml-32 absolute w-full sm:w-[480px] h-[480px] bg-[#3D3D3D]"></div>
                <div class="px-2 z-10 mt-24 m-auto">A ni ◼️ che place for your bookmarks</div>
                <div class="px-2 z-10 m-auto">🟥🟧🟨🟩🟦🟦🟪10,000+ categories </div>
                <div class="px-2 z-10 m-auto">↪️⏺⏭🔄 Customise your bookmark placements</div>
                <div class="px-2 z-10 m-auto">Browser bookmarking remains unchanged</div>
                <div class="px-2 z-10 m-auto">No cost until you have 🔋🕹🕹⛱⛱🛵🛵 “dayyyys” to learn</div>
                <div class="px-2 z-10 m-auto">📱🖥📡 Connect multiple devices or browsers</div>
            </div>
            <div class="h-40 sm:h-80"></div>
            <div class="relative flex flex-col px-6 ">
                <div class="m-auto text-xl sm:text-3xl font-bold  mb-8">How we earn</div>
                <div class="m-auto sm:text-2xl mb-3 px-12 py-4 bg-orange-700">Pay 1$ only for exploring a category for 1 day</div>
                <div class="m-auto sm:text-2xl mb-3 px-12 py-4 bg-orange-900">Pay 4$ only for exploring a category for 5 days</div>
                <div class="m-auto text-sm">more options available</div>
            </div>
            <div class="h-20"></div>
            <div class="relative flex px-6 flex-col gap-2">
                <div class=" text-xl sm:text-3xl font-bold mb-6">What you get for free</div>
                <div class="flex flex-col mb-4">
                    <div class="m-auto text-xl sm:text-2xl mb-2">Auto Bookmark Categorisation</div>
                    <div class="m-auto px-8 py-4 bg-yellow-700">
                        <div>WHY IS THIS IMPORTANT?</div>
                        <div class="font-bold">We need a helping hand to do tedious and unintelligent work</div>
                    </div>
                </div>
                <div class="flex flex-col mb-4">
                    <div class="m-auto  text-xl sm:text-2xl mb-2">Open on any device</div>
                    <div class="m-auto px-8 py-4 bg-yellow-700">
                        <div>WHY IS THIS IMPORTANT?</div>
                        <div class="font-bold">We need to have easy access to something we want to use</div>
                    </div>
                </div>
                <div class="flex flex-col mb-4">
                    <div class="m-auto  text-xl sm:text-2xl mb-2">Customize your own bookmark hub manually</div>
                    <div class="m-auto px-8 py-4 bg-yellow-700">
                        <div>WHY IS THIS IMPORTANT?</div>
                        <div class="font-bold">A place we spend time in should be according to our understanding</div>
                    </div>
                </div>
                <div class="flex flex-col mb-4">
                    <div class="m-auto  text-xl sm:text-2xl mb-2">Keep paid, explored bookmarks</div>
                    <div class="m-auto px-8 py-4 bg-yellow-700">
                        <div>WHY IS THIS IMPORTANT?</div>
                        <div class="font-bold">Don’t lose value from money you already spend</div>
                    </div>
                </div>
                <div class="flex flex-col mb-4">
                    <div class="m-auto text-xl  sm:text-2xl mb-2">No cost until you have days to learn</div>
                    <div class="m-auto px-8 py-4 bg-yellow-700">
                        <div>WHY IS THIS IMPORTANT?</div>
                        <div class="font-bold">You don’t have to spend if you do not have time this month</div>
                    </div>
                </div>
            </div>
            <div class="h-40"></div>
            <div class="hidden sm:block ">
            <div class="pl-12 sm:pl-64 mb-8 text-left underline text-3xl ">use for</div>
                <div class="flex flex-row justify-center gap-40  text-2xl text-left">
                    <div>
                        <div class="flex flex-row gap-5">
                            <div>career</div>
                            <div class="mt-2 -rotate-90"><img src={DownTriangle} class="w-3" alt="Down"/></div>
                        </div>
                    </div>
                    <div>
                        <div class="flex flex-row gap-5">
                            <div>love</div>
                            <div class="mt-2 -rotate-90"><img src={DownTriangle} class="w-3" alt="Down"/></div>
                        </div>
                    </div>
                    <div>
                        <div class="flex flex-row gap-5">
                            <div>life</div>
                            <div class="mt-2 -rotate-90"><img src={DownTriangle} class="w-3" alt="Down"/></div>
                        </div>
                    </div>
                    <div>
                        <div class="flex flex-row gap-5">
                            <div>business</div>
                            <div class="mt-2 -rotate-90"><img src={DownTriangle} class="w-3" alt="Down"/></div>
                        </div>
                    </div>
                </div>
                <div class="mt-16 flex flex-row justify-center gap-48  text-2xl text-left">
                    <div>
                    </div>
                    <div>
                        <div  class="flex flex-row gap-5">
                            <div>art</div>
                            <div class="mt-2 -rotate-90"><img src={DownTriangle} class="w-3" alt="Down"/></div>
                        </div>
                    </div>
                    <div>
                        <div class="flex flex-row gap-5">
                            <div >sports</div>
                            <div class="mt-2 -rotate-90"><img src={DownTriangle} class="w-3" alt="Down"/></div>
                        </div>
                    </div>
                    <div>
                    </div>
                </div>
                <div class="mt-16 flex flex-row justify-center gap-48  text-2xl text-left">
                    <div>
                    </div>
                    <div>
                    </div>
                    <div>
                        <div class="flex flex-row gap-5">
                            <div>karate</div>
                            <div class="mt-2 -rotate-90"><img src={DownTriangle} class="w-3" alt="Down"/></div>
                        </div>
                    </div>
                    <div>
                    </div>
                </div>
            </div>
            <div class="h-48"></div>
            <div class="hidden sm:block relative">
                <div class="ml-80 absolute w-60 h-60 rotate-45 bg-[#103C05]"></div>
                <div class="ml-[600px] absolute rounded-full w-60 h-60 bg-[#235717]"></div>
                <div class="z-10 pl-12 sm:pl-64 mb-8 text-left underline text-3xl ">for</div>
                <div class=" flex flex-row justify-center gap-20  text-2xl text-left">
                    <div class="z-10">
                        <div>friends</div>
                        <div>family</div>
                        <div>teachers</div>
                        <div>pandits</div>
                        <div>workers</div>
                    </div>
                    <div class="z-10">
                        <div>entrepreneurs</div>
                        <div>operators</div>
                        <div>researchers</div>
                        <div>managers</div>
                        <div>specialists</div>
                    </div>
                    <div class="z-10">
                        <div>Cooks</div>
                        <div>Architects</div>
                        <div>Lawyers</div>
                        <div>Landlords</div>
                        <div>SMB Owners</div>
                    </div>
                    <div class="z-10">
                        <div>Product managers</div>
                        <div>Marketers</div>
                        <div>Operation performers</div>
                        <div>IT leaders</div>
                        <div>Bankers</div>
                    </div>
                </div>
            </div>
            <div class="h-60"></div>
        </div>
    );
}